const getProcessArgs = args => args.slice(2).join(' ');

export default getProcessArgs;